module.exports = __webpack_public_path__ + "assets/img/needLife.59130d52.png";